import { openSteps } from "@/mocks/openSteps";
import SectionHeading from "./SectionHeading";

export default function Process() {
  return (
    <section id="process" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="开箱流程"
          title="一次完整开箱，通常分成四步"
          desc="开箱不只是剪开纸箱。把过程固定成四个步骤，能让记录更有条理，也方便之后回看某一期的具体感受。"
        />

        <ol className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {openSteps.map((step, index) => (
            <li
              key={step.id}
              className="relative rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${step.icon} text-xl`} />
              </span>
              <span className="absolute right-5 top-5 font-heading text-2xl text-background-300">
                0{index + 1}
              </span>
              <h3 className="mt-4 text-base font-medium text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {step.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}